import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AvisoComponent } from './component/aviso/aviso.component';
import { ContendientesComponent } from './component/contendientes/contendientes.component';
import { BuscadorComponent } from './component/buscador/buscador.component';
import { RenunciasComponent } from './component/renuncias/renuncias.component';
import { LicenciasComponent } from './component/licencias/licencias.component';
import { FuncionesComponent } from './component/funciones/funciones.component';
import { BuscadorDosComponent } from './component/buscador-dos/buscador-dos.component';
import { HomeComponent } from './component/home/home.component';
import { VisorComponent } from './component/visor/visor.component';

const routes: Routes = [
  { path: 'home', component: HomeComponent },
  { path: 'inicio', component: AvisoComponent },
  { path: 'contendientes', component: ContendientesComponent },
  { path: 'documento/:tipo/:oid', component: VisorComponent },
  // { path: 'diputados', component: RenunciasComponent },
  { path: 'renuncias', component: RenunciasComponent },
  { path: 'licencias', component: LicenciasComponent },
  { path: 'funciones', component: FuncionesComponent },
  { path: 'buscador/:termino', component: BuscadorComponent },
  { path: 'buscadorb/:termino', component: BuscadorDosComponent },
  { path: 'aviso', component: AvisoComponent },
  { path: '**', pathMatch: 'full', redirectTo: 'home' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
